// Modules
import React, {useState} from "react";

// Components
import CorporateHat from "components/shared/Header/CorporateHat";
import Header from "components/shared/Header/Header";
import Navbar from "components/shared/Navbar/Navbar";
import Stripe from "components/shared/Stripe/Stripe";

// Types
import {useAppSelector} from "redux/hooks";
import {stripeActiveSelector} from "redux/shared/userInfoSlice";
import { UserInfo } from "interfaces/shared/userInfo";

interface HeaderContentProps {
    loading: boolean;
    userInfoClientSide: UserInfo;
}

const HeaderContent = ({loading, userInfoClientSide}: HeaderContentProps) => {
    const [isHeaderBurgerOpen, setIsHeaderBurgerOpen] = useState<boolean>(false);
    const [isProfileOpen, setIsProfileOpen] = useState<boolean>(false);

    const [isCorporateHatOpen, setIsCorporateHatOpen] = useState(false);
    const [corpHatAccordionStates, setCorpHatAccordionStates] = useState([false, false]);

    const stripeActive = useAppSelector(stripeActiveSelector);

  return (
      <>
          <CorporateHat isCorporateHatOpen={isCorporateHatOpen} setIsCorporateHatOpen={setIsCorporateHatOpen}
                        corpHatAccordionStates={corpHatAccordionStates} setCorpHatAccordionStates={setCorpHatAccordionStates}
                        isHeaderBurgerOpen={isHeaderBurgerOpen} setIsHeaderBurgerOpen={setIsHeaderBurgerOpen}
                        isProfileOpen={isProfileOpen} setIsProfileOpen={setIsProfileOpen} />

          {stripeActive.length && stripeActive[0].text ? <Stripe stripeActive={stripeActive} isMobileStripe={false} /> : ""}

          <Header loading={loading}
                  userInfoClientSide={userInfoClientSide}
                  isHeaderBurgerOpen={isHeaderBurgerOpen} setIsHeaderBurgerOpen={setIsHeaderBurgerOpen}
                  isProfileOpen={isProfileOpen} setIsProfileOpen={setIsProfileOpen} />
          <Navbar isHeaderBurgerOpen={isHeaderBurgerOpen}
                  setIsHeaderBurgerOpen={setIsHeaderBurgerOpen} setIsProfileOpen={setIsProfileOpen}
                  setIsCorporateHatOpen={setIsCorporateHatOpen} setCorpHatAccordionStates={setCorpHatAccordionStates}
                  htmlHeaderClientSide={userInfoClientSide.htmlHeader} />

          {stripeActive.length && stripeActive[0].text? <Stripe stripeActive={stripeActive} isMobileStripe={true} /> : ""}
      </>
  )
};

export default HeaderContent;
